"use client";

import { useEffect, useState } from "react";
import {
  X,
  Upload,
  Plus,
  Trash,
  Star,
  Award,
  FlameIcon as Fire,
} from "lucide-react";
import { useCloud } from "../hooks/useCloud";
import toast from "react-hot-toast";
import store from "../store";

// Mock toast if not available
const mockToast = {
  success: (msg) => console.log("Success:", msg),
  error: (msg) => console.log("Error:", msg),
};

export function AddMenuItemForm({
  menuItem,
  categories = [],
  onClose,
  onSubmit,
}) {
  const { addPriceRule, deletePriceRule } = useCloud();
  const DISABLED_FEATURES = [""];
  const [showVariationModal, setShowVariationModal] = useState(false);
  const [showAddOnModal, setShowAddOnModal] = useState(false);
  const [showPriceRuleModal, setShowPriceRuleModal] = useState(false);
  // Update the currentVariation state to include variationPriceRules instead of customerPricing
  const [currentVariation, setCurrentVariation] = useState({
    name: "",
    price: "",
    variationPriceRules: [],
  });
  const [currentAddOn, setCurrentAddOn] = useState({ name: "", price: "" });
  const [currentAddOnIndex, setCurrentAddOnIndex] = useState(null);
  const [currentPriceRule, setCurrentPriceRule] = useState({
    room: "",
    table: "",
    time: "",
    timeStart: "",
    timeEnd: "",
    price: "",
  });
  const [deletedVariations, setDeletedVariations] = useState([]);
  const [deletedAddOns, setDeletedAddOns] = useState([]);
  const [currentVariationIndex, setCurrentVariationIndex] = useState(null);
  const [currentPriceRuleIndex, setCurrentPriceRuleIndex] = useState(null);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  // Replace currentCustomerPrice with currentVariationPriceRule
  const [currentVariationPriceRule, setCurrentVariationPriceRule] = useState({
    room: "",
    table: "",
    time: "",
    timeStart: "",
    timeEnd: "",
    price: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    rank: 0,
    amount: "",
    price: "",
    halfPrice: "",
    acPrice: "",
    description: "",
    image: "",
    imgUrl: "",
    status: true,
    itmNo: "",
    veg: false,
    nonveg: false,
    specify: false,
    chefspe: false,
    bestSellar: false,
    reating: "0",
    rating: "0",
    gst: "0",
    pkgCharge: "0",
    variant: [],
    addOns: [],
    subCategoryName: "Na",
    categoryId:
      categories && categories.length > 0 ? categories[0].categoryId : "",
    category:
      categories && categories.length > 0 ? categories[0].categoryName : "",
    priceRules: [],
    status: true,
    varient: {
      status: true,
      items: [],
    },
    isAddOns: {
      status: true,
      items: [],
    },
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [variations, setVariations] = useState([]);
  const [addOns, setAddOns] = useState([]);
  const [priceRules, setPriceRules] = useState([]);

  useEffect(() => {
    if (menuItem) {
      // Map the base properties to form data
      setFormData({
        id: menuItem.id || "",
        name: menuItem.itemName || "",
        rank: menuItem.rank || 0,
        amount: menuItem.price?.toString() || "",
        price: menuItem.price?.toString() || "",
        halfPrice: "",
        acPrice: "",
        description: menuItem.description || "",
        image:
          menuItem.images && menuItem.images.length > 0
            ? menuItem.images[0]
            : "",
        imgUrl: "",
        status: menuItem.status === "active",
        itmNo: menuItem.restaurantCode || "",
        veg: menuItem.itemType?.veg || false,
        nonveg: menuItem.itemType?.nonVeg || false,
        specify: menuItem.itemType?.spicy || false,
        chefspe: menuItem.itemType?.chefSpecial || false,
        bestSellar: menuItem.itemType?.bestSeller || false,
        reating: menuItem.rating?.toString() || "0",
        rating: menuItem.rating?.toString() || "0",
        gst: "0",
        pkgCharge: "0",
        variant: [],
        addOns: [],
        subCategoryName: "Na",
        categoryId: menuItem.categoryId || "",
        category: menuItem.categoryDetails?.categoryName || "",
        priceRules: menuItem.priceRule || [],
        categoryDetails: menuItem.categoryDetails || null,
        varient: {
          status: true,
          items: [],
        },
        isAddOns: {
          status: true,
          items: [],
        },
      });

      // Handle image preview
      if (menuItem.images && menuItem.images.length > 0 && menuItem.images[0]) {
        setImagePreview(menuItem.images[0]);
      }

      // Handle variations
      if (menuItem.variation && menuItem.variation.length > 0) {
        const variations = menuItem.variation.map((variant) => ({
          id: variant.id || "",
          name: variant.name || "",
          amount: variant.price?.toString() || "0",
          price: variant.price?.toString() || "0",
          image: variant.image || "",
          status: variant.status || "active",
          priceRules: variant.priceRule || "[]",
          variationPriceRules: Array.isArray(variant.priceRule)
            ? variant.priceRule.map(parseRuleString)
            : [],
        }));
        setVariations(variations);
      } else {
        setVariations([]);
      }

      // Handle add-ons
      if (menuItem.addOn && menuItem.addOn.length > 0) {
        const addOns = menuItem.addOn.map((addon) => ({
          id: addon.id || "",
          name: addon.name || "",
          amount: addon.price?.toString() || "0",
          price: addon.price?.toString() || "0",
          status: addon.status || "active",
        }));
        setAddOns(addOns);
      } else {
        setAddOns([]);
      }

      // Handle price rules
      if (menuItem.priceRule && menuItem.priceRule.length > 0) {
        try {
          const parsedRules = Array.isArray(menuItem.priceRule)
            ? menuItem.priceRule.map(parseRuleString)
            : [];
          setPriceRules(parsedRules);
        } catch (error) {
          console.error("Error parsing price rules:", error);
          setPriceRules([]);
        }
      } else {
        setPriceRules([]);
      }

      // Set rating
      setRating(Number.parseFloat(menuItem.rating?.toString() || "0"));
    }
  }, [menuItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let amount = formData.amount;
    let reating = formData.reating;
    if (name == "price") {
      amount = value;
    }
    if (name == "rating") {
      reating = value;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      amount,
      reating,
    }));

    // Update category name if categoryId changes
    if (name === "categoryId" && categories) {
      const selectedCategory = categories.find((cat) => cat.id === value);
      if (selectedCategory) {
        setFormData((prev) => ({
          ...prev,
          categoryId: value,
          category: selectedCategory.name,
        }));
      }
    }
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFormData((prev) => ({
          ...prev,
          image: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  // Star rating handler
  const handleRatingChange = (newRating) => {
    setRating(newRating);
    setFormData((prev) => ({
      ...prev,
      rating: newRating.toString(),
      reating: newRating.toString(),
    }));
  };

  // Variation handling
  // Update the openVariationModal function to handle variationPriceRules
  const openVariationModal = (variation = null, index = null) => {
    if (variation) {
      let priceRules = [];
      try {
        priceRules = JSON.parse(variation.priceRules).map(parseRuleString);
      } catch (error) {
        console.error("Error parsing price rules:", error);
      }

      setCurrentVariation({
        ...variation,
        variationPriceRules: priceRules || [],
      });
      setCurrentVariationIndex(index);
    } else {
      setCurrentVariation({ name: "", price: "", variationPriceRules: [] });
      setCurrentVariationIndex(null);
    }
    setShowVariationModal(true);
  };

  const saveVariation = () => {
    if (currentVariationIndex !== null) {
      // Edit existing
      const updatedVariations = [...variations];
      updatedVariations[currentVariationIndex] = currentVariation;
      setVariations(updatedVariations);
    } else {
      // Add new
      setVariations([...variations, currentVariation]);
    }
    setShowVariationModal(false);
  };

  const removeVariation = (index) => {
    const deletedVariation = variations[index];
    const updatedVariations = variations.filter((_, i) => i !== index);
    setVariations(updatedVariations);
    setDeletedVariations((prev) => {
      prev.push(deletedVariation);
      return prev;
    });
  };

  // Add-on handling
  const openAddOnModal = (addon = null, index = null) => {
    if (addon) {
      setCurrentAddOn(addon);
      setCurrentAddOnIndex(index);
    } else {
      setCurrentAddOn({ name: "", price: "" });
      setCurrentAddOnIndex(null);
    }
    setShowAddOnModal(true);
  };

  const saveAddOn = () => {
    if (currentAddOnIndex !== null) {
      // Edit existing
      const updatedAddOns = [...addOns];
      updatedAddOns[currentAddOnIndex] = currentAddOn;
      setAddOns(updatedAddOns);
    } else {
      // Add new
      setAddOns([...addOns, currentAddOn]);
    }
    setShowAddOnModal(false);
  };

  const removeAddOn = (index) => {
    const deletedAddon = addOns[index];
    const updatedAddOns = addOns.filter((_, i) => i !== index);
    setAddOns(updatedAddOns);
    setDeletedAddOns((prev) => {
      prev.push(deletedAddon);
      return prev;
    });
  };

  // Price rule handling
  const openPriceRuleModal = (rule = null, index = null) => {
    if (rule) {
      setCurrentPriceRule(rule);
      setCurrentPriceRuleIndex(index);
    } else {
      setCurrentPriceRule({ room: "", table: "", time: "", price: "" });
      setCurrentPriceRuleIndex(null);
    }
    setShowPriceRuleModal(true);
  };

  const stringifyRule = ({ price, room, table, time, timeEnd, timeStart }) => {
    const _room = room == "All" ? "*" : room;
    const _table = table == "All" ? "*" : table;
    const _time = time == "Whole Day" ? "*" : time;
    return `${_room},${_table},${_time},${price}`;
  };

  const parseRuleString = (rule) => {
    // If rule is a string (old format), parse it
    if (typeof rule === "string") {
      const [room, table, time, price] = rule.split(",");

      return {
        id: "", // No ID in the old format
        room: room === "*" ? "All" : room,
        table: table === "*" ? "All" : table,
        time: time === "*" ? "Whole Day" : time,
        timeStart: time !== "*" ? time.split("-")[0] : "",
        timeEnd: time !== "*" ? time.split("-")[1] : "",
        price: Number.parseFloat(price),
        status: "active", // Default status
      };
    }
    // If rule is an object (new format), map it to our expected structure
    else if (typeof rule === "object" && rule !== null) {
      return {
        id: rule.id || "",
        room: rule.room === "*" ? "All" : rule.room,
        table: rule.table === "*" ? "All" : rule.table,
        time:
          rule.startTime && rule.endTime
            ? `${rule.startTime}-${rule.endTime}`
            : "Whole Day",
        timeStart: rule.startTime || "",
        timeEnd: rule.endTime || "",
        price: Number.parseFloat(rule.price),
        status: rule.status || "active",
      };
    }

    // Return default empty rule if input is invalid
    return {
      id: "",
      room: "",
      table: "",
      time: "",
      timeStart: "",
      timeEnd: "",
      price: 0,
      status: "active",
    };
  };

  const savePriceRule = () => {
    const finalRule = { ...currentPriceRule };
  
    // Format time range if custom time is selected
    if (
      currentPriceRule.time === "Custom" &&
      currentPriceRule.timeStart &&
      currentPriceRule.timeEnd
    ) {
      finalRule.time = `${currentPriceRule.timeStart}-${currentPriceRule.timeEnd}`;
    }
  
    if (currentPriceRuleIndex !== null) {
      // Edit existing rule
      const updatedRules = [...priceRules];
      updatedRules[currentPriceRuleIndex] = finalRule;
      setPriceRules(updatedRules);
    } else {
      // Add new rule
      setPriceRules([...priceRules, finalRule]);
    }
  
    // Close modal
    setShowPriceRuleModal(false);
  
    // Reset current rule
    setCurrentPriceRule({
      room: "",
      table: "",
      time: "",
      timeStart: "",
      timeEnd: "",
      price: "",
    });
  };

  const removePriceRule = (index) => {
    // Remove the rule at the specified index
    const updatedRules = priceRules.filter((_, i) => i !== index);
    setPriceRules(updatedRules);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const menuItem = {
      id: formData.id || "",
      categoryId: formData.categoryId,
      itemName: formData.name,
      description: formData.description,
      images: formData.image ? [formData.image] : [],
      price: Number.parseInt(formData.price) || 0,
      rating: Number.parseFloat(formData.rating || 0),
      rank: Number.parseInt(formData.rank) || 0,
      itemType: {
        veg: formData.veg,
        nonVeg: formData.nonveg,
        spicy: formData.specify,
        chefSpecial: formData.chefspe,
        bestSeller: formData.bestSellar,
        id: formData.itemType?.id || "6024bf6d015e0099c5e1130c",
      },
      outOfStock: false,
      restaurantCode: formData.itmNo || "NA",
      variation: variations.map((variant) => ({
        id: variant.id || "",
        name: variant.name,
        price: Number.parseInt(variant.amount) || 0,
        image: variant.image || "",
        priceRule: variant.priceRules || [],
        status: "active",
      })),
      addOns: addOns.map((addon) => ({
        id: addon.id || undefined,
        name: addon.name,
        price: Number.parseInt(addon.amount) || 0,
        status: "active",
      })),
      priceRule:
        priceRules.length > 0 ? priceRules : [],
      itemSuggestion: [],
      status: formData.status ? "active" : "inactive",
      categoryDetails: formData.categoryDetails || null,
    };
    onSubmit(menuItem);
  };

  // Replace addCustomerPricing with addVariationPriceRule
  const addVariationPriceRule = () => {
    const finalRule = { ...currentVariationPriceRule };

    // Format time range if custom time is selected
    if (
      currentVariationPriceRule.time === "Custom" &&
      currentVariationPriceRule.timeStart &&
      currentVariationPriceRule.timeEnd
    ) {
      finalRule.time = `${currentVariationPriceRule.timeStart}-${currentVariationPriceRule.timeEnd}`;
    }

    if (
      finalRule.room &&
      finalRule.table &&
      finalRule.time &&
      finalRule.price
    ) {
      try {
        const rule = stringifyRule(finalRule);
        addPriceRule({
          type: "VARIATION",
          data: { id: currentVariation?.id, rules: [rule] },
        })
          .then((data) => {
            if (data) {
              setVariations((prev) => {
                prev.forEach((variation) => {
                  if (variation.id == currentVariation.id) {
                    variation.priceRules = JSON.stringify(data.rules);
                  }
                });
                return prev;
              });
              setCurrentVariation({
                ...currentVariation,
                priceRules: JSON.stringify(data.rules),
                variationPriceRules: [
                  ...(currentVariation.variationPriceRules || []),
                  finalRule,
                ],
              });
              setCurrentVariationPriceRule({
                room: "",
                table: "",
                time: "",
                timeStart: "",
                timeEnd: "",
                price: "",
              });
              toast.success(data.message || "Price rule added successfully");
            }
          })
          .catch((e) => {
            toast.error("Something went wrong please try again!");
          });
      } catch (e) {
        toast.error("Something went wrong please try again!");
      }
    }
  };

  // Replace removeCustomerPricing with removeVariationPriceRule
  const removeVariationPriceRule = async (index) => {
    try {
      const updatedRules = [...currentVariation.variationPriceRules];
      const _removeRule = updatedRules[index];
      const _rule = stringifyRule(_removeRule);
      const res = await deletePriceRule({
        type: "VARIATION",
        data: { id: currentVariation?.id, rule: _rule },
      });

      if (res) {
        toast.success(res.message || "Price rule deleted successfully");

        setVariations((prev) => {
          prev.forEach((variation) => {
            if (variation.id == currentVariation.id) {
              variation.priceRules = JSON.stringify(res.rules);
            }
          });
          return prev;
        });
        updatedRules.splice(index, 1);
        setCurrentVariation({
          ...currentVariation,
          priceRules: JSON.stringify(res.rules),
          variationPriceRules: updatedRules,
        });
      } else {
        toast.error("Failed, please try again");
      }
    } catch (e) {
      toast.error("Something went wrong please try again!");
    }
  };

  return (
    <div
      className="fixed inset-0 bg-white z-50 flex flex-col h-screen"
      style={{ zIndex: 502 }}
    >
      <div className="px-4 py-3 flex items-center justify-between border-b">
        <h2 className="text-base font-medium text-gray-800">
          {menuItem ? "Edit Menu Item" : "Add New Menu Item"}
        </h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700 rounded-full p-1 hover:bg-gray-100 transition-all duration-200"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <form
          id="menu-item-form"
          onSubmit={handleSubmit}
          className="max-w-5xl mx-auto space-y-8"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Left Column */}
            <div className="space-y-6">
              <div>
                <h3 className="text-sm font-medium text-gray-700 mb-2">
                  Menu Item Image
                </h3>
                <div
                  className="border-2 border-dashed border-gray-300 rounded-xl p-6 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 transition-all duration-200 bg-gray-50"
                  onClick={() =>
                    document.getElementById("image-upload").click()
                  }
                >
                  {imagePreview ? (
                    <div className="relative w-full">
                      <img
                        src={
                          imagePreview ||
                          "/placeholder.svg?height=160&width=200" ||
                          "/placeholder.svg"
                        }
                        alt="Menu item preview"
                        className="w-full h-40 object-contain"
                      />
                      <button
                        type="button"
                        className="absolute -top-2 -right-2 bg-white text-gray-600 p-1 rounded-full hover:bg-gray-100 shadow-sm transition-all duration-200"
                        onClick={(e) => {
                          e.stopPropagation();
                          setImagePreview(null);
                          setFormData((prev) => ({ ...prev, image: "" }));
                        }}
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ) : (
                    <>
                      <Upload className="w-6 h-6 text-gray-400 mb-2" />
                      <p className="text-sm text-gray-500">
                        Click to upload menu item image
                      </p>
                      <p className="mt-1 text-xs text-gray-400">
                        PNG, JPG, GIF up to 5MB
                      </p>
                    </>
                  )}
                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleImageUpload}
                  />
                </div>
              </div>

              <div className="mt-4">
                <label
                  htmlFor="price"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Price*
                </label>
                <input
                  id="price"
                  name="price"
                  type="text"
                  required
                  value={formData.amount || formData.price}
                  onChange={handleChange}
                  className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none font-bold"
                  placeholder="0.00"
                />
              </div>

              <div>
                <h3 className="text-sm font-medium text-gray-700 mb-2">
                  Additional Information
                </h3>
                <div className="space-y-3">
                  <div>
                    <label
                      htmlFor="itmNo"
                      className="block text-xs text-gray-500 mb-1"
                    >
                      ID Number
                    </label>
                    <input
                      id="itmNo"
                      name="itmNo"
                      type="text"
                      value={formData.itmNo}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                      placeholder="Enter ID"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="rating"
                      className="block text-xs text-gray-500 mb-1"
                    >
                      Rating (0-5)
                    </label>
                    <div className="flex items-center">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          type="button"
                          className="focus:outline-none"
                          onMouseEnter={() => setHoverRating(star)}
                          onMouseLeave={() => setHoverRating(0)}
                          onClick={() => handleRatingChange(star)}
                        >
                          <Star
                            className={`h-6 w-6 ${
                              (hoverRating || rating) >= star
                                ? "fill-yellow-400 text-yellow-400"
                                : "text-gray-300"
                            }`}
                          />
                        </button>
                      ))}
                      <span className="ml-2 text-sm text-gray-600">
                        ({rating})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="md:col-span-2 space-y-6">
              <div>
                <h3 className="text-sm font-medium text-gray-700 mb-2">
                  Menu Item Details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-xs text-gray-500 mb-1"
                    >
                      Menu Item Name*
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                      placeholder="Enter menu item name"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="categoryId"
                      className="block text-xs text-gray-500 mb-1"
                    >
                      Category*
                    </label>
                    <select
                      id="categoryId"
                      name="categoryId"
                      required
                      value={formData.categoryId}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                    >
                      {categories && categories.length > 0 ? (
                        categories.map((category) => (
                          <option
                            key={category.categoryId}
                            value={category.categoryId}
                          >
                            {category.categoryName}
                          </option>
                        ))
                      ) : (
                        <option value="">No categories available</option>
                      )}
                    </select>
                  </div>

                  <div>
                    <label
                      htmlFor="subCategoryName"
                      className="block text-xs text-gray-500 mb-1"
                    >
                      Sub Category
                    </label>
                    <input
                      id="subCategoryName"
                      name="subCategoryName"
                      type="text"
                      value={formData.subCategoryName}
                      onChange={handleChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                      placeholder="Enter subcategory"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="description"
                    className="block text-xs text-gray-500 mb-1"
                  >
                    Description
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    rows={4}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                    placeholder="Enter menu item description"
                  />
                </div>

                {/* Types Section */}
                <div className="mt-6">
                  <h3 className="text-sm font-medium text-gray-700 mb-2">
                    Types
                  </h3>
                  <div className="flex flex-wrap gap-1.5">
                    <label
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${
                        formData.status
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="status"
                        checked={formData.status}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">Active</span>
                    </label>

                    <label
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${
                        formData.veg
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="veg"
                        checked={formData.veg}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">Vegetarian</span>
                    </label>

                    <label
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${
                        formData.nonveg
                          ? "bg-red-100 text-red-800"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="nonveg"
                        checked={formData.nonveg}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">Non-Veg</span>
                    </label>

                    <label
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${
                        formData.chefspe
                          ? "bg-purple-100 text-purple-800"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="chefspe"
                        checked={formData.chefspe}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <Award className="mr-0.5 h-3 w-3" />
                      <span className="text-xs">Chef's Special</span>
                    </label>

                    <label
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${
                        formData.bestSellar
                          ? "bg-amber-100 text-amber-800"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="bestSellar"
                        checked={formData.bestSellar}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <Fire className="mr-0.5 h-3 w-3" />
                      <span className="text-xs">Best Seller</span>
                    </label>

                    <label
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${
                        formData.specify
                          ? "bg-blue-100 text-blue-800"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="specify"
                        checked={formData.specify}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">spicy</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Variations */}
          <div>
            <h3 className="text-base font-medium text-gray-700 mb-4">
              Variations
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
              {/* Add this to the variations mapping to show customer pricing indicator */}
              {variations.map((variation, index) => (
                <div
                  key={index}
                  className="bg-gray-50 rounded-xl p-4 hover:shadow-md transition-all duration-200 cursor-pointer border border-gray-100 hover:border-blue-200"
                  onClick={() => openVariationModal(variation, index)}
                >
                  <div className="flex items-center justify-between mb-1">
                    <div className="font-medium text-sm">
                      {variation.name || "Unnamed Variation"}
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeVariation(index);
                      }}
                      className="p-1 text-gray-400 hover:text-red-500 transition-colors rounded-full hover:bg-gray-200"
                    >
                      <Trash className="w-3.5 h-3.5" />
                    </button>
                  </div>
                  <div className="text-sm text-gray-500">
                    {variation.amount || "0.00"}
                  </div>
                  {variation.variationPriceRules &&
                    variation.variationPriceRules.length > 0 && (
                      <div className="mt-1 text-xs text-blue-600">
                        {variation.variationPriceRules.length} custom price
                        {variation.variationPriceRules.length > 1 ? "s" : ""}
                      </div>
                    )}
                </div>
              ))}

              {/* Add Variation Button */}
              <button
                type="button"
                onClick={() => openVariationModal()}
                className="border-2 border-dashed border-gray-300 rounded-xl p-4 flex flex-col items-center justify-center text-gray-500 hover:border-blue-400 hover:text-blue-600 transition-all duration-200 h-full"
              >
                <Plus className="w-5 h-5 mb-1" />
                <span className="text-sm">Add Variation</span>
              </button>
            </div>
          </div>

          {/* Add-ons */}
          <div className="border-t pt-6">
            <h3 className="text-base font-medium text-gray-700 mb-4">Add On</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
              {addOns.map((addon, index) => (
                <div
                  key={index}
                  className="bg-gray-50 rounded-xl p-4 hover:shadow-md transition-all duration-200 cursor-pointer border border-gray-100 hover:border-blue-200"
                  onClick={() => openAddOnModal(addon, index)}
                >
                  <div className="flex items-center justify-between mb-1">
                    <div className="font-medium text-sm">
                      {addon.name || "Unnamed Add-on"}
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeAddOn(index);
                      }}
                      className="p-1 text-gray-400 hover:text-red-500 transition-colors rounded-full hover:bg-gray-200"
                    >
                      <Trash className="w-3.5 h-3.5" />
                    </button>
                  </div>
                  <div className="text-sm text-gray-500">
                    {addon.amount || "0.00"}
                  </div>
                </div>
              ))}

              {/* Add Add-on Button */}
              <button
                type="button"
                onClick={() => openAddOnModal()}
                className="border-2 border-dashed border-gray-300 rounded-xl p-4 flex flex-col items-center justify-center text-gray-500 hover:border-blue-400 hover:text-blue-600 transition-all duration-200 h-full"
              >
                <Plus className="w-5 h-5 mb-1" />
                <span className="text-sm">Add Add-on</span>
              </button>
            </div>
          </div>

          {/* Price Rules */}
          {!DISABLED_FEATURES.includes("priceRule") && menuItem !== null && (
            <div className="border-t pt-6">
              <h3 className="text-base font-medium text-gray-700 mb-4">
                Custom Price
              </h3>

              {/* Input row for adding new rules - full width */}
              <div className="grid grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 mb-4 w-full">
                <div>
                  <select
                    className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                    value={currentPriceRule.room}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        room: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Room</option>
                    <option value="All">All Rooms</option>
                    {store.rooms.map((room) => (
                      <option key={room.roomName} value={room.roomName}>
                        {room.roomName}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <select
                    className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                    value={currentPriceRule.table}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        table: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Table</option>
                    <option value="All">All Tables</option>

                    {Object.values(store.tables)
                      .filter(
                        (table) => currentPriceRule.room == table.roomName
                      )
                      .map((table) => (
                        <option key={table.tableNo} value={table.tableNo}>
                          {table.tableNo}
                        </option>
                      ))}
                  </select>
                </div>
                <div>
                  <select
                    className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                    value={currentPriceRule.time}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        time: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Time</option>
                    <option value="Whole Day">Whole Day</option>
                    <option value="Custom">Custom Time Range</option>
                  </select>

                  {currentPriceRule.time === "Custom" && (
                    <div className="flex items-center space-x-1 mt-2">
                      <select
                        className="w-full px-2 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                        value={currentPriceRule.timeStart || ""}
                        onChange={(e) => {
                          const startTime = e.target.value;
                          const endTime = currentPriceRule.timeEnd || "";
                          setCurrentPriceRule({
                            ...currentPriceRule,
                            timeStart: startTime,
                            time: "Custom",
                          });
                        }}
                      >
                        <option value="">Start</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={`${i === 0 ? 12 : i}:00 AM`}>
                            {i === 0 ? 12 : i}:00 AM
                          </option>
                        ))}
                        {[...Array(12)].map((_, i) => (
                          <option
                            key={i + 12}
                            value={`${i === 0 ? 12 : i}:00 PM`}
                          >
                            {i === 0 ? 12 : i}:00 PM
                          </option>
                        ))}
                      </select>
                      <span className="text-gray-500">-</span>
                      <select
                        className="w-full px-2 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                        value={currentPriceRule.timeEnd || ""}
                        onChange={(e) => {
                          const startTime = currentPriceRule.timeStart || "";
                          const endTime = e.target.value;
                          setCurrentPriceRule({
                            ...currentPriceRule,
                            timeEnd: endTime,
                            time: "Custom",
                          });
                        }}
                      >
                        <option value="">End</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={`${i === 0 ? 12 : i}:00 AM`}>
                            {i === 0 ? 12 : i}:00 AM
                          </option>
                        ))}
                        {[...Array(12)].map((_, i) => (
                          <option
                            key={i + 12}
                            value={`${i === 0 ? 12 : i}:00 PM`}
                          >
                            {i === 0 ? 12 : i}:00 PM
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Price"
                    className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                    value={currentPriceRule.price}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        price: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="flex items-center">
                  <button
                    type="button"
                    onClick={savePriceRule}
                    className="p-2 bg-blue-600 rounded-full text-white hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow"
                    title="Add rule"
                  >
                    <Plus className="w-4 h-4" />
                  </button>
                </div>
              </div>

              {/* List of existing rules - full width */}
              <div className="space-y-2 w-full">
                {priceRules.map((rule, index) =>
                  rule.room || rule.table || rule.time || rule.price ? (
                    <div
                      key={index}
                      className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-100 hover:border-blue-200 hover:shadow-sm transition-all duration-200"
                    >
                      <div className="grid grid-cols-4 gap-4 w-full text-sm">
                        <div>
                          <span className="text-gray-500">Room:</span>{" "}
                          {rule.room || "Any"}
                        </div>
                        <div>
                          <span className="text-gray-500">Table:</span>{" "}
                          {rule.table || "Any"}
                        </div>
                        <div>
                          <span className="text-gray-500">Time:</span>{" "}
                          {rule.time || "Any"}
                        </div>
                        <div>
                          <span className="text-gray-500">Price:</span>{" "}
                          {rule.price || "0.00"}
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          type="button"
                          onClick={() => removePriceRule(index)}
                          className="p-1 text-red-500 hover:text-red-700 transition-colors rounded-full hover:bg-gray-200"
                          title="Delete rule"
                        >
                          <Trash className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="border-t pt-6 flex justify-end">
            <button
              type="submit"
              className="px-6 py-2.5 bg-blue-600 rounded-full text-sm font-medium text-white hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow"
            >
              {menuItem ? "Update Menu Item" : "Save Menu Item"}
            </button>
          </div>
        </form>
      </div>

      {/* Variation Modal */}
      {showVariationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-lg max-w-[70%] w-full p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-medium text-gray-800">
                {currentVariationIndex !== null
                  ? "Edit Variation"
                  : "Add Variation"}
              </h3>
              <button
                type="button"
                onClick={() => setShowVariationModal(false)}
                className="text-gray-500 hover:text-gray-700 rounded-full p-1 hover:bg-gray-100 transition-all duration-200"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label
                  htmlFor="variation-name"
                  className="block text-sm text-gray-600 mb-1"
                >
                  Variation Name
                </label>
                <input
                  id="variation-name"
                  type="text"
                  value={currentVariation.name}
                  onChange={(e) =>
                    setCurrentVariation({
                      ...currentVariation,
                      name: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="e.g. Small, Medium, Large"
                />
              </div>

              <div>
                <label
                  htmlFor="variation-price"
                  className="block text-sm text-gray-600 mb-1"
                >
                  Price
                </label>
                <input
                  id="variation-price"
                  type="text"
                  value={currentVariation.amount}
                  onChange={(e) =>
                    setCurrentVariation({
                      ...currentVariation,
                      amount: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                  placeholder="0.00"
                />
              </div>
              {/* Add this to the Variation Modal before the buttons */}
              {currentVariationIndex !== null && menuItem && (
                <div className="mt-4">
                  <label className="block text-sm text-gray-600 mb-1">
                    Custom Pricing (Optional)
                  </label>
                  <div className="rounded-lg pt-4">
                    <div className="grid grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 mb-4 w-full">
                      <div>
                        <select
                          className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                          value={currentVariationPriceRule.room}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              room: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Room</option>
                          <option value="All">All Rooms</option>
                          {store.rooms.map((room) => (
                            <option key={room.roomName} value={room.roomName}>
                              {room.roomName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <select
                          className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                          value={currentVariationPriceRule.table}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              table: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Table</option>
                          <option value="All">All Tables</option>
                          {Object.values(store.tables)
                            .filter(
                              (table) =>
                                currentVariationPriceRule.room == table.roomName
                            )
                            .map((table) => (
                              <option key={table.tableNo} value={table.tableNo}>
                                {table.tableNo}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div>
                        <select
                          className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                          value={currentVariationPriceRule.time}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              time: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Time</option>
                          <option value="Whole Day">Whole Day</option>
                          <option value="Custom">Custom Time Range</option>
                        </select>

                        {currentVariationPriceRule.time === "Custom" && (
                          <div className="flex items-center space-x-1 mt-2">
                            <select
                              className="w-full px-2 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                              value={currentVariationPriceRule.timeStart || ""}
                              onChange={(e) => {
                                const startTime = e.target.value;
                                const endTime =
                                  currentVariationPriceRule.timeEnd || "";
                                setCurrentVariationPriceRule({
                                  ...currentVariationPriceRule,
                                  timeStart: startTime,
                                  time: "Custom",
                                });
                              }}
                            >
                              <option value="">Start</option>
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i}
                                  value={`${i === 0 ? 12 : i}:00 AM`}
                                >
                                  {i === 0 ? 12 : i}:00 AM
                                </option>
                              ))}
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i + 12}
                                  value={`${i === 0 ? 12 : i}:00 PM`}
                                >
                                  {i === 0 ? 12 : i}:00 PM
                                </option>
                              ))}
                            </select>
                            <span className="text-gray-500">-</span>
                            <select
                              className="w-full px-2 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                              value={currentVariationPriceRule.timeEnd || ""}
                              onChange={(e) => {
                                const startTime =
                                  currentVariationPriceRule.timeStart || "";
                                const endTime = e.target.value;
                                setCurrentVariationPriceRule({
                                  ...currentVariationPriceRule,
                                  timeEnd: endTime,
                                  time: "Custom",
                                });
                              }}
                            >
                              <option value="">End</option>
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i}
                                  value={`${i === 0 ? 12 : i}:00 AM`}
                                >
                                  {i === 0 ? 12 : i}:00 AM
                                </option>
                              ))}
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i + 12}
                                  value={`${i === 0 ? 12 : i}:00 PM`}
                                >
                                  {i === 0 ? 12 : i}:00 PM
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>
                      <div>
                        <input
                          type="text"
                          placeholder="Price"
                          className="w-full px-3 py-2 text-sm border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                          value={currentVariationPriceRule.price}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              price: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="flex items-center">
                        <button
                          type="button"
                          onClick={addVariationPriceRule}
                          className="p-2 bg-blue-600 rounded-full text-white hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow"
                          title="Add rule"
                        >
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>
                    </div>

                    {/* List of custom pricing rules */}
                    <div className="space-y-2 w-full">
                      {currentVariation.variationPriceRules &&
                        currentVariation.variationPriceRules.map(
                          (rule, index) => (
                            <div
                              key={index}
                              className="flex items-center justify-between p-3 rounded-lg border border-gray-100 bg-gray-50 hover:border-blue-200 hover:shadow-sm transition-all duration-200 "
                            >
                              <div className="grid grid-cols-4 gap-4 w-full text-sm">
                                <div>
                                  <span className="text-gray-500">Room:</span>{" "}
                                  {rule.room || "Any"}
                                </div>
                                <div>
                                  <span className="text-gray-500">Table:</span>{" "}
                                  {rule.table || "Any"}
                                </div>
                                <div>
                                  <span className="text-gray-500">Time:</span>{" "}
                                  {rule.time || "Any"}
                                </div>
                                <div>
                                  <span className="text-gray-500">Price:</span>{" "}
                                  {rule.price || "0.00"}
                                </div>
                              </div>
                              <div className="flex items-center space-x-2">
                                <button
                                  type="button"
                                  onClick={() =>
                                    removeVariationPriceRule(index)
                                  }
                                  className="p-1 text-red-500 hover:text-red-700 transition-colors rounded-full hover:bg-gray-200"
                                  title="Delete rule"
                                >
                                  <Trash className="w-3.5 h-3.5" />
                                </button>
                              </div>
                            </div>
                          )
                        )}
                    </div>
                  </div>
                </div>
              )}

              <div className="flex justify-end mt-6 space-x-3">
                <button
                  type="button"
                  onClick={() => setShowVariationModal(false)}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={saveVariation}
                  className="px-4 py-2 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow"
                >
                  {currentVariationIndex !== null ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add-on Modal */}
      {showAddOnModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-medium text-gray-800">
                {currentAddOnIndex !== null ? "Edit Add-on" : "Add Add-on"}
              </h3>
              <button
                type="button"
                onClick={() => setShowAddOnModal(false)}
                className="text-gray-500 hover:text-gray-700 rounded-full p-1 hover:bg-gray-100 transition-all duration-200"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label
                  htmlFor="addon-name"
                  className="block text-sm text-gray-600 mb-1"
                >
                  Add-on Name
                </label>
                <input
                  id="addon-name"
                  type="text"
                  value={currentAddOn.name}
                  onChange={(e) =>
                    setCurrentAddOn({ ...currentAddOn, name: e.target.value })
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="e.g. Extra Cheese, Mushrooms"
                />
              </div>

              <div>
                <label
                  htmlFor="addon-price"
                  className="block text-sm text-gray-600 mb-1"
                >
                  Price
                </label>
                <input
                  id="addon-price"
                  type="text"
                  value={currentAddOn.amount}
                  onChange={(e) =>
                    setCurrentAddOn({ ...currentAddOn, amount: e.target.value })
                  }
                  className="w-full px-3 py-2 border-b border-gray-300 focus:border-blue-500 focus:outline-none transition-all duration-200 rounded-none"
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="flex justify-end mt-6 space-x-3">
              <button
                type="button"
                onClick={() => setShowAddOnModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-all duration-200"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={saveAddOn}
                className="px-4 py-2 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow"
              >
                {currentAddOnIndex !== null ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
